module.exports = __webpack_public_path__ + "img/14.1730f52e.jpg";